import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const userGroupsFilterMixin = {
  data() {
    return {
      filteredUserGroups: [],
    };
  },
  watch: {
    userGroups: {
      immediate: true,
      handler() {
        this.filteredUserGroups = this.userGroups;
      },
    },
  },
  methods: {
    userGroupsFilterMethod(query) {
      this.filteredUserGroups = searchWithDiacritics(query, this.userGroups, ['fullname'], 'users');
    },
    handleUserGroupsVisibleChange() {
      setTimeout(() => {
        this.filteredUserGroups = this.userGroups;
      }, 50);
    },
  },
};
